import { Injectable } from '@angular/core';
import { GapiLoaderService } from 'src/app/app-common/services/gapi-loader.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleDrivePickerService {
  private _successCallback: (value: unknown) => void;
  private _errorCallback: (reason?: any) => void;
  private _pickerInitialized: boolean;

  constructor(private gapiLoaderService: GapiLoaderService) {
    this.gapiLoaderService.load().then((gapi) => {
      gapi.load('client:picker', () => {
        this._pickerInitialized = true;
      });
    });
  }

  createPicker(
    accessToken: string,
    viewId: string,
    pickerCallback: (data: any) => void,
    mimeTypes?: string,
  ) {
    const view = mimeTypes
      ? new window.google.picker.DocsView(viewId).setMimeTypes(mimeTypes)
      : viewId;

    const pickerBuilder = new window.google.picker.PickerBuilder()
      .setOAuthToken(accessToken)
      .setAppId('614513768474')
      .addView(view)
      .setCallback(pickerCallback);

    if (mimeTypes) {
      pickerBuilder.setSelectableMimeTypes(mimeTypes);
    }

    const picker = pickerBuilder.build();
    picker.setVisible(true);
  }

  async _openWindow(accessToken: string, viewId: string, mimeTypes?: string) {
    if (!this._pickerInitialized) {
      this._errorCallback(new Error('Google Picker failed to initialize'));
      return;
    }

    this.createPicker(
      accessToken,
      viewId,
      this._pickerCallback.bind(this),
      mimeTypes,
    );
  }

  _pickerCallback(data) {
    switch (data.action) {
      case 'picked':
        const doc = data.docs[0];
        const result = {
          id: doc.id,
          name: doc.name,
        };
        this._successCallback(result);
        break;

      case 'cancel':
        this._successCallback(null);
        break;

      default:
        break;
    }
  }

  async open(
    accessToken: string,
    viewId: string = 'spreadsheets',
    mimeTypes?: string,
  ) {
    return new Promise((resolve, reject) => {
      this._successCallback = resolve;
      this._errorCallback = reject;
      this._openWindow(accessToken, viewId, mimeTypes);
    });
  }
}
